export default "__VITE_ASSET__Df2GeI$Y__"